import React from "react";
import { ReactComponent as MapICon } from 'assets/map.svg';
import { ReactComponent as CloseIcon } from 'assets/close.svg';
import Text from 'components/Text/Text';
import styles from './ListPractitioners.module.scss';
import { Step, store } from "stores/Store";

interface IRoutingModal {
  isOpen: boolean;
  handleClose: () => void;
  onClear: () => void;
  practitioners: any[];
  setPractitioners: (practitioners: any[]) => void;
}

const ListPractitioners: React.FC<IRoutingModal> = ({
  isOpen,
  handleClose,
  onClear,
  practitioners,
  setPractitioners
}) => {


  const removePractitioner = (practitioner: any) => {
    setPractitioners(practitioners?.filter((p) => p.practitionerName !== practitioner.practitionerName));
  }

  const createRoute = () => {
    store.setRoutingModalStep(Step.CREATE_ROUTE);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.practitionersWrapper}>
        {practitioners?.map((pract, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', borderBottom: '1px solid #eee' }}>
            <span>{pract.practitionerName}</span>
            <CloseIcon width={25} height={25} fill='red' onClick={() => removePractitioner(pract)} style={{ cursor: 'pointer' }} />
          </div>
        ))}
      </div>

      <div style={{
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0
      }}>
        <div style={{
          width: '100%',
          height: '1px',
          backgroundColor: '#ddd',
          margin: '20px 0'
        }} />

        <div style={{
          display: 'flex',
          justifyContent: 'space-around',

        }}>
          <div onClick={createRoute} className={styles.column}>
            <MapICon width={30} height={30} />
            <Text>Create Route</Text>
          </div>

          <div onClick={onClear} className={styles.column}>
            <CloseIcon width={30} height={30} />
            <Text>Clear</Text>
          </div>
        </div>
      </div>
    </div>
  )

}

export default ListPractitioners;